<template>
	<div class="main">
		<section class="panel" v-if="showView != 'treaty'">
			<header class="panel-heading">
				<h2 class="panel-title">{{title}}</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-12">
						<label class="col-xs-3 col-md-u column-required">學生身分別：</label>
						<div class="col-xs-9 col-md-10" v-if="$route.name == 'stay.apply.view'">
							{{ currentStudentIdentityLabel }}
						</div>
						<div class="col-xs-9 col-md-10" v-else>
							<div class="col-xs-4 col-md-2" v-for="(item, index) in identiList" :key="index">
								<label :for="'stuIdentity_'+index">
									<input :id="'stuIdentity_'+index" name="stuIdentity" type="radio" @change="changeStuIdentity" v-validate="'required|included:1,2,3,4,5,6'" :value="item.commCode" v-model="dormitoryApply.stuIdentity" /> {{item.commValue}}
								</label>
							</div>
							<span class="text-danger" v-show="errors.has('stuIdentity')">{{ errors.first('stuIdentity') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="isForeignStudent">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">國家/地區：</label>
						<div class="col-xs-9 col-md-7" v-if="$route.name == 'stay.apply.view'">
							{{ stuBase.natnName }}
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<select name="natnName" v-model="stuBase.natnName" class="selbox" v-validate="'required'" @change="changeCountry">
								<option value="">請選擇</option>
								<option v-for="item in countryList" :key="item.isoCode" :value="item.name">{{ item.name }} (+{{ item.dialCode }})</option>
							</select>
							<span class="text-danger" v-show="errors.has('natnName')">{{ errors.first('natnName') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '+ isRequired">身分證字號：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.idno}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<input type="text" name="idno" v-validate="'required'" @change="changeDataGetStuBase" v-model="stuBase.idno" placeholder="身份證號碼|護照" class="form-control" />
							<span class="text-danger" v-show="errors.has('idno')">{{ errors.first('idno') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '+ isRequired">姓&emsp;&emsp;名：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.name}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<input type="text" name="name" v-validate="'required'" v-model="stuBase.name" placeholder="姓名" class="form-control" maxlength="100"/>
							<span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '+ isRequired">性&emsp;&emsp;別：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.sexStr}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<label for="Sex_1" class="radio-inline">
								<input type="radio" v-validate="'required'" id="sex_1" name="sex" v-model="stuBase.sex" value="M" /> 男
							</label>
							<label for="Sex_2" class="radio-inline">
								<input type="radio" v-validate="'required'" id="sex_2" name="sex" v-model="stuBase.sex" value="F" /> 女
							</label>
							<span class="text-danger" v-show="errors.has('sex')">{{ errors.first('sex') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '">學&emsp;&emsp;號：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.account}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<!-- <input type="text" name="account" v-model="stuBase.account" placeholder="學號" class="form-control" maxlength="20"/> -->
							<!-- <span class="text-danger" v-show="errors.has('account')">{{ errors.first('account') }}</span> -->
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 column-required'">生&emsp;&emsp;日：</label>
						<div class="col-xs-9 col-md-7" v-if="$route.name == 'stay.apply.view'">
							{{customFormatter(stuBase.birthDay)}}
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<datepicker name="birthDay" :format="customFormatter" :language="zh" v-validate="'required'" :disabled-dates="birthState.disabledDates" v-model="stuBase.birthDay" input-class="form-control" placeholder="生日" :style="{width:'auto', display:'inline-block'}" />
							<span class="text-danger" v-show="errors.has('birthDay')">{{ errors.first('birthDay') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '+isRequired">學&emsp;&emsp;制：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.deptSsymStr}}</div>
						<div v-else class="col-xs-6 col-md-7">
							<select name="ssym" v-model="ssym" class="selbox" v-validate="'required'">
								<option value="">請選擇</option>
								<option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
							<span class="text-danger" v-show="errors.has('ssym')">{{ errors.first('ssym') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label v-bind:class="'col-xs-3 col-md-5 '+isRequired">科系班級：</label>
						<div v-if="isInfo" class="col-xs-9 col-md-7">{{stuBase.deptCodeStr}}-{{stuBase.drade}}年{{stuBase.dradeClass}}班</div>
						<div v-else class="col-xs-6 col-md-7">
							<select name="dept" v-model="dept" class="selbox" v-validate="'required'">
								<option value="">請選擇</option>
								<option v-for="(item,key) in selectDeptList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
							<span class="text-danger" v-show="errors.has('dept')">{{ errors.first('dept') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group" v-if="!isInfo">
						<div class="col-xs-offset-util-3 col-xs-3 col-md-6">
							<div class="col-xs-9 col-md-9">
								<input type="text" name="stuBase.drade" v-model="stuBase.drade" class="form-control" style="width:80%" maxlength="1">
								<span class="text-danger" v-show="errors.has('stuBase.drade')">{{ errors.first('stuBase.drade') }}</span>
							</div>
							<label class="col-xs-2 col-md-2">年</label>
						</div>
						<div class="col-xs-3 col-md-6">
							<div class="col-xs-9 col-md-9">
								<input type="text" name="stuBase.dradeClass" v-model="stuBase.dradeClass" class="form-control" style="width:80%" maxlength="1">
								<span class="text-danger" v-show="errors.has('stuBase.dradeClass')">{{ errors.first('stuBase.dradeClass') }}</span>
							</div>
							<label class="col-xs-2 col-md-2">班</label>
						</div>

					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">聯絡電話：</label>
						<div class="col-xs-9 col-md-7" v-if="$route.name == 'stay.apply.view'">
							{{stuBase.tel}}
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<input type="text" name="tel" v-model="stuBase.tel" :placeholder="isForeignStudent ? '國碼' : '聯絡電話'" v-validate="telValidationRule" class="form-control" :readonly="isForeignStudent" />
							<span class="text-danger" v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
						</div>

					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">行動電話：</label>
						<div class="col-xs-9 col-md-7" v-if="$route.name == 'stay.apply.view'" >
							{{stuBase.phone}}
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<input type="text" name="phone" v-model="stuBase.phone" v-validate="phoneValidationRule" placeholder="行動電話" class="form-control" maxlength="20" />
							<span class="text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
						</div>

					</div>
					<div class="col-md-4 form-group">
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">常用信箱：</label>
						<div class="col-xs-9 col-md-7" v-if="$route.name == 'stay.apply.view'" >
							{{stuBase.extMail}}
						</div>
						<div class="col-xs-9 col-md-7" v-else>
							<input type="email" id="email" name="extMail" v-model="stuBase.extMail" placeholder="常用信箱" class="form-control" maxlength="50"/>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5">學校信箱：</label>
						<div class="col-xs-9 col-md-7">
							{{ stuBase.schMail }}
						</div>
					</div>
					<div class="col-md-4 form-group">
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">家長姓名：</label>
						<div v-if="isInfo">{{stuBase.parentName}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<input type="text" name="parentName" v-validate="'required'" v-model="stuBase.parentName" placeholder="家長姓名" class="form-control" maxlength="10"/>
							<span class="text-danger" v-show="errors.has('parentName')">{{ errors.first('parentName') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">關　　係：</label>
						<div v-if="isInfo">{{stuBase.kinship}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<input type="text" name="kinship" v-validate="'required|max:5'" v-model="stuBase.kinship" placeholder="父子|母子|祖孫..." class="form-control" maxlength="5"/>
							<span class="text-danger" v-show="errors.has('kinship')">{{ errors.first('kinship') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-3 col-md-5 column-required">家長電話：</label>
						<div v-if="isInfo">{{stuBase.parentPhone}}</div>
						<div v-else class="col-xs-9 col-md-7">
							<input type="text" name="parentPhone" v-validate="parentPhoneValidationRule" v-model="stuBase.parentPhone" placeholder="家長電話" class="form-control" maxlength="20" />
							<span class="text-danger" v-show="errors.has('parentPhone')">{{ errors.first('parentPhone') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="isInfo">
						<label class="col-xs-3 col-md-u">戶籍地址：</label>
						<div class="col-xs-9 col-md-10">
							{{ stuBase.resiFullAddress || stuBase.resiAddr }}
						</div>
					</div>
					<div class="col-md-12 form-group" v-else>
						<label class="col-xs-3 col-md-u form-group column-required">戶籍地址：</label>
						<div v-if="dormitoryApply.stuIdentity == 4">
							<div class="col-xs-offset-util-3 col-xs-9 col-md-10 form-group">
								<div class="col-xs-12 col-md-7">
									<input type="text" id="resiAddr" name="resiAddr" v-validate="'required'" class="form-control" v-model="stuBase.resiAddr" placeholder="地址" maxlength="100"/>
									<span class="text-danger" v-show="errors.has('resiAddr')">{{ errors.first('resiAddr') }}</span>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="col-xs-3 col-md-2 form-group">
								<select v-model="stuBase.resiCityId" name="resiCityId" class="selbox" v-validate="'required'" @change="getResiArea()">
									<option disabled value="">請選擇</option>
									<option v-for="(item,key) in resiCityList" :key="key" :value="item.cityId">{{ item.cityName }}
									</option>
								</select>
								<span class="text-danger" v-show="errors.has('resiCityId')">{{ errors.first('resiCityId') }}</span>
							</div>
							<div class="col-xs-3 col-md-2 form-group">
								<select v-model="stuBase.resiAreaId" name="resiAreaId" class="selbox" v-validate="'required'">
									<option disabled value="">請選擇</option>
									<option v-for="(item,key) in resiAreaList" :key="key" :value="item.areaId">{{ item.areaName }}
									</option>
								</select>
								<span class="text-danger" v-show="errors.has('resiAreaId')">{{ errors.first('resiAreaId') }}</span>
							</div>
							<div class="col-xs-offset-util-3 col-xs-9 col-md-5 form-group">
								<div class="col-xs-12 col-md-7">
									<input type="text" id="resiAddr" name="resiAddr" v-validate="'required'" class="form-control" v-model="stuBase.resiAddr" placeholder="地址" maxlength="100"/>
									<span class="text-danger" v-show="errors.has('resiAddr')">{{ errors.first('resiAddr') }}</span>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="$route.name == 'stay.apply.view'">
						<label class="col-xs-3 col-md-u">通訊地址：</label>
						<div class="col-xs-9 col-md-10">
							{{ stuBase.mailFullAddress || stuBase.mailAddr }}
						</div>
					</div>
					<div class="col-md-12 form-group" v-else>
						<label class="col-xs-3 col-md-u form-group column-required">通訊地址：</label>
						<div v-if="isForeignStudent">
							<div class="col-xs-offset-util-3 col-xs-9 col-md-10 form-group">
								<div class="col-xs-12 col-md-7">
									<input type="text" id="mailAddr" name="mailAddr" v-validate="'required'" class="form-control" v-model="stuBase.mailAddr" placeholder="地址" maxlength="100"/>
									<span class="text-danger" v-show="errors.has('mailAddr')">{{ errors.first('mailAddr') }}</span>
								</div>
								<label class="col-md-5">
									<input type="checkbox" @click="copyAddr($event)">地址同上
								</label>
							</div>
						</div>
						<div v-else>
							<div class="col-xs-3 col-md-2 form-group">
								<select v-model="stuBase.mailCityId" name="mailCityId" class="selbox" v-validate="'required'" @change="getMailArea">
									<option disabled value="">請選擇</option>
									<option v-for="(item,key) in mailCityList" :key="key" :value="item.cityId">{{ item.cityName }}
									</option>
								</select>
								<span class="text-danger" v-show="errors.has('mailCityId')">{{ errors.first('mailCityId') }}</span>
							</div>
							<div class="col-xs-3 col-md-2 form-group">
								<select v-model="stuBase.mailAreaId" name="mailAreaId" class="selbox" v-validate="'required'">
									<option disabled value="">請選擇</option>
									<option v-for="(item,key) in mailAreaList" :key="key" :value="item.areaId">{{ item.areaName }}
									</option>
								</select>
								<span class="text-danger" v-show="errors.has('mailAreaId')">{{ errors.first('mailAreaId') }}</span>
							</div>
							<div class="col-xs-offset-util-3 col-xs-9 col-md-5 form-group">
								<div class="col-xs-12 col-md-7">
									<input type="text" id="mailAddr" name="mailAddr" v-validate="'required'" class="form-control" v-model="stuBase.mailAddr" placeholder="地址" maxlength="50"/>
									<span class="text-danger" v-show="errors.has('mailAddr')">{{ errors.first('mailAddr') }}</span>
								</div>
								<label class="col-md-5">
									<input type="checkbox" @click="copyAddr($event)">地址同上
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group">
						<label class="col-xs-3 col-md-u form-group">個人疾病史：</label>
						<div class="col-xs-9 col-md-10 form-group">
							<div class="col-xs-4 col-md-2 " v-for="(item, index) in diseaseList" :key="index">
								<label :for="'diseaseHis_'+index">
									<input :id="'diseaseHis_'+index" name="diseaseHis" type="checkbox" :value="item.commCode" v-model="diseaseHisArray" :disabled="$route.name == 'stay.apply.view'">{{item.commValue}}
								</label>
								<div v-if="item.commCode == '9'">
									<div v-if="diseaseHisArray.includes('9')">
										<input type="text" name="diseaseHisOther" class="form-control" v-model="diseaseHisOther" v-validate="'required'"/>
										<span class="text-danger" v-show="errors.has('diseaseHisOther')">{{ errors.first('diseaseHisOther') }}</span>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="row form-group" v-if="dormitoryApply.stuIdentity">
					<div class="col-md-12">
						<header>
							<h5 v-if="dormitoryApply.stuIdentity == 1">一般生</h5>
							<h5 v-else-if="dormitoryApply.stuIdentity == 2">低收入戶</h5>
							<h5 v-else-if="dormitoryApply.stuIdentity == 3">離島學生</h5>
							<h5 v-else-if="dormitoryApply.stuIdentity == 4">境外生</h5>
							<h5 v-else-if="dormitoryApply.stuIdentity == 5">中低收入戶</h5>
							<h5 v-else-if="dormitoryApply.stuIdentity == 6">特殊境遇</h5>
						</header>
						<div class="row form-group" >
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">學生2吋照片上傳：</label>
								<label class="col-xs-6 col-md-3" for="stuPhotoFile" v-if="$route.name != 'stay.apply.view'" >
									<div style="display:none;">
										<input type="file" id="stuPhotoFile" style="width: 100%" accept=".pdf,image/*" ref="stuPhoto" key="stuPhoto-file" @change="getStuPhoto($event)" />
										<input type="hidden" name="stuPhoto" v-model="dormitoryApply.stuPhoto" key="stuPhoto-input" v-validate="'required'" value="" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('stuPhoto')">{{ errors.first('stuPhoto') }}</span>
								</label>
								<p>
									{{dormitoryApply.stuPhoto}}
									<a v-if="stuPhotoPreviewPDF" :href="stuPhotoPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="stuPhotoPreview">
								<a :href="stuPhotoPreview" target="_blank">
									<img class="img-fluid" :src="stuPhotoPreview" alt="" style="width:200px; "/>
								</a>

							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity != 4">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">身分證正面上傳：</label>
								<label class="col-xs-6 col-md-3 " for="idCardPositFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="idCardPositFile" style="width: 100%" accept=".pdf,image/*" ref="idCardPosit" key="idCardPosit-file" @change="getIdCardPosit($event)" />
										<input type="hidden" name="idCardPosit" v-model="stuBase.idCardPosit" key="idCardPosit-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('idCardPosit')">{{ errors.first('idCardPosit') }}</span>
								</label>
								<p>
									{{stuBase.idCardPosit}}
									<a v-if="idCardPositPreviewPDF" :href="idCardPositPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="idCardPositPreview">
								<a :href="idCardPositPreview" target="_blank">
									<img class="img-fluid" :src="idCardPositPreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity != 4">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">身分證反面上傳：</label>
								<label class="col-xs-6 col-md-3" for="idCardReverFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="idCardReverFile" style="width: 100%" accept=".pdf,image/*" ref="idCardRever" key="idCardRever-file" @change="getIdCardRever($event)" />
										<input type="hidden" name="idCardRever" v-model="stuBase.idCardRever" key="idCardRever-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('idCardRever')">{{ errors.first('idCardRever') }}</span>
								</label>
								<p>
									{{stuBase.idCardRever}}
									<a v-if="idCardReverPreviewPDF" :href="idCardReverPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="idCardReverPreview">
								<a :href="idCardReverPreview" target="_blank">
									<img class="img-fluid" :src="idCardReverPreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity != 4">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">
									戶籍謄本(3個月內)或新式戶口名簿上傳(須為詳細記事)：<br/> &emsp;
									<a href="javascript:;" class="btn-link" @mouseover="display()" @mouseout="disappear()">上傳範例</a>
									<div id="box" class="box" style="z-index:1000;"><h4 class="blue">新式戶口名簿樣本</h4><img src="../../../assets/images/1595926019829.jpg" width="500px"></div>
								</label>
								<label class="col-xs-6 col-md-3 " for="householdFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="householdFile" style="width: 100%" accept=".pdf,image/*" ref="household" key="household-file" @change="getHousehold($event)" />
										<input type="hidden" name="household" v-model="dormitoryApply.household" key="household-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('household')">{{ errors.first('household') }}</span>
								</label>
								<p>
									{{dormitoryApply.household}}
									<a v-if="householdPreviewPDF" :href="householdPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="householdPreview">
								<a :href="householdPreview" target="_blank">
									<img class="img-fluid" :src="householdPreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity == 4">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">護照上傳：</label>
								<label class="col-xs-6 col-md-3" for="passport" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="passport" style="width: 100%" accept=".pdf,image/*" ref="passport" key="passport-file" @change="getPassPort($event)" />
										<input type="hidden" name="passport" v-model="dormitoryApply.passport" key="passport-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('passport')">{{ errors.first('passport') }}</span>
								</label>
								<p>
									{{dormitoryApply.passport}}
									<a v-if="passportPreviewPDF" :href="passportPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="passportPreview">
								<a :href="passportPreview" target="_blank">
									<img class="img-fluid" :src="passportPreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity == 4">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3">居留證上傳：</label>
								<label class="col-xs-6 col-md-3" for="residentFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="residentFile" style="width: 100%" accept=".pdf,image/*" ref="resident" key="resident-file" @change="getResident($event)" />
										<input type="hidden" name="resident" key="resident-input" v-model="dormitoryApply.resident" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('resident')">{{ errors.first('resident') }}</span>
								</label>
								<p>
									{{dormitoryApply.resident}}
									<a v-if="residentPreviewPDF" :href="residentPreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="residentPreview">
								<a :href="residentPreview" target="_blank">
									<img class="img-fluid" :src="residentPreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity == 2">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">低收入戶證明文件：</label>
								<label class="col-xs-6 col-md-3" for="lowIncomeProveFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="lowIncomeProveFile" style="width: 100%" accept=".pdf,image/*" ref="lowIncomeProve" key="lowIncomeProve-file" @change="getLowIncomeProve($event)" />
										<input type="hidden" name="lowIncomeProve" v-model="dormitoryApply.lowIncomeProve" key="lowIncomeProve-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('lowIncomeProve')">{{ errors.first('lowIncomeProve') }}</span>
								</label>
								<p>
									{{dormitoryApply.lowIncomeProve}}
									<a v-if="lowIncomeProvePreviewPDF" :href="lowIncomeProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="lowIncomeProvePreview">
								<a :href="lowIncomeProvePreview" target="_blank">
									<img class="img-fluid" :src="lowIncomeProvePreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity == 5">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">中低收入戶證明文件：</label>
								<label class="col-xs-6 col-md-3" for="lowIncomeProveFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="lowIncomeProveFile" style="width: 100%" accept=".pdf,image/*" ref="lowIncomeProve" key="lowIncomeProve-file" @change="getLowIncomeProve($event)" />
										<input type="hidden" name="lowIncomeProve" v-model="dormitoryApply.lowIncomeProve" key="lowIncomeProve-input" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('lowIncomeProve')">{{ errors.first('lowIncomeProve') }}</span>
								</label>
								<p>
									{{dormitoryApply.lowIncomeProve}}
									<a v-if="lowIncomeProvePreviewPDF" :href="lowIncomeProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="lowIncomeProvePreview">
								<a :href="lowIncomeProvePreview" target="_blank">
									<img class="img-fluid" :src="lowIncomeProvePreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div class="row form-group" v-if="dormitoryApply.stuIdentity == 6">
							<div class="col-md-12 form-group">
								<label class="col-xs-6 col-md-3 column-required">特殊境遇證明文件上傳：</label>
								<label class="col-xs-6 col-md-3" for="specialProveFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="specialProveFile" style="width: 100%" accept=".pdf,image/*" ref="specialProve" key="specialProve-file" @change="getSpecialProve($event)" />
										<input type="hidden" name="specialProve" key="specialProve-input" v-model="dormitoryApply.specialProve" v-validate="'required'" />
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('specialProve')">{{ errors.first('specialProve') }}</span>
								</label>
								<p>
									{{dormitoryApply.specialProve}}
									<a v-if="specialProvePreviewPDF" :href="specialProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="specialProvePreview">
								<a :href="specialProvePreview" target="_blank">
									<img class="img-fluid" :src="specialProvePreview" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
					</div>
				</div>
				<!-- && (this.dormitoryApply.stuIdentity != 2 && this.dormitoryApply.stuIdentity != 3 && this.dormitoryApply.stuIdentity != 4) -->
				<div v-if="dormitoryApply.dormitoryType == 'N' && !isForeignStudent">
					<div class="row form-group" style="margin-bottom: 15px">
						<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">是否有辦理住宿費就學貸款?：</label>
							<div class="col-xs-6 col-md-9">
								<div class="col-xs-6 col-md-1 radio-inline">
									<label for="isStuLoan1">
										<input type="radio" id="isStuLoan1" name="isStuLoan" :disabled="$route.name == 'stay.apply.view'" v-validate="'required'" v-model="dormitoryApply.isStuLoan" value="Y" />是
									</label>
								</div>
								<div class="col-xs-6 col-md-1 radio-inline">
									<label for="isStuLoan2">
										<input type="radio" id="isStuLoan2" name="isStuLoan" :disabled="$route.name == 'stay.apply.view'" v-validate="'required'" v-model="dormitoryApply.isStuLoan" value="N" />否
									</label>
								</div>
								<span class="text-danger" v-show="errors.has('isStuLoan')">{{ errors.first('isStuLoan') }}</span>
							</div>
						</div>
					</div>

					<div v-if="dormitoryApply.isStuLoan == 'Y'">
						<div class="row form-group">
							<div class="col-md-12">
								<label class="col-xs-6 col-md-3 column-required">就學貸款證明上傳(對保單)：</label>
								<label class="col-xs-6 col-md-3" for="stuLoanProveFile" v-if="$route.name != 'stay.apply.view'">
									<div style="display:none;">
										<input type="file" id="stuLoanProveFile" style="width: 100%" accept=".pdf,image/*" ref="stuLoanProve" key="stuLoanProve-file" @change="getStuLoanProve($event)" />
										<input type="hidden" name="stuLoanProve" v-model="dormitoryApply.stuLoanProve" v-validate="'required'">
									</div>
									<a class="btn btn-default">請選擇檔案</a>
									<span class="text-danger" v-show="errors.has('stuLoanProve')">{{ errors.first('stuLoanProve') }}</span>
								</label>
								<p>
									{{dormitoryApply.stuLoanProve}}
									<a v-if="stuLoanProvePreviewPDF" :href="stuLoanProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
								</p>
							</div>
							<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="stuLoanProvePreview">
								<a :href="stuLoanProvePreview" target="_blank">
									<img class="img-fluid" :src="stuLoanProvePreview" alt="" style="width:200px;"/>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div v-if="$route.name != 'stay.apply.view' && dormitoryApply.dormitoryType == 'N'">
					<div class="col-md-12 form-group">
						<label>
							<span :style="{color:'#FF0000'}">我已閱讀下列「申請注意事項」: </span>請打勾 <input type="checkbox" v-validate="'required'" name="isCheckBoxOk" v-model="isCheckBoxOk" />
							<span class="text-danger" v-show="errors.has('isCheckBoxOk')">{{ errors.first('isCheckBoxOk') }}</span>
						</label>
						<p>1. 申請人以本校日間部四技在學學生(不含碩士班)為原則。</p>
						<p>2. 樓層及房號由學務處一狀況統一分配，分配床位後不得任意調換，無法滿足個人需求時，敬請包涵。</p>
						<p>3. 住宿期間不含寒暑假，且學年結束時應將私人物品搬離，保持宿舍淨空，假期住宿另依規定申請。</p>
						<p>4. 入住學生都須遵守宿舍相關規範，如不遵守將視情況予以退宿。</p>
					</div>
				</div>
				<div v-if="dormitoryApply.dormitoryType == 'V'">
					<div class="row form-group">
						<div class="col-md-12">
							<label class="col-xs-12 column-required">住宿原因：</label>
							<div class="col-xs-12 col-md-10">
								<div class="col-xs-4 col-md-2" v-for="(item, index) in roomRsList" :key="index" @change="chnageRoomReason">
									<label :for="'roomReason_'+index">
										<input :id="'roomReason_'+index" name="roomReason" type="radio" v-validate="'required|included:1,2,9'" :disabled="$route.name == 'stay.apply.view'" :value="item.commCode" v-model="dormitoryApply.roomReason" /> {{item.commValue}}
									</label>
								</div>
								<span class="text-danger" v-show="errors.has('roomReason')">{{ errors.first('roomReason') }}</span>
							</div>
						</div>
					</div>
					<div class="row form-group" v-if="dormitoryApply.roomReason">
						<div class="col-md-12">
							<header>
								<h5 v-if="dormitoryApply.roomReason == 1">在校工讀</h5>
								<h5 v-else-if="dormitoryApply.roomReason == 2">專題研究</h5>
								<h5 v-else-if="dormitoryApply.roomReason == 9">其他原因</h5>
							</header>
							<div class="row form-group">
								<div class="col-md-12 form-group">
									<label class="col-xs-6 col-md-3 column-required">{{unitAdminTitle}}</label>
									<label class="col-xs-6 col-md-3" v-if="$route.name == 'stay.apply.view'">
										{{ dormitoryApply.unitAdmin }}
									</label>
									<label class="col-xs-6 col-md-3" v-else>
										<input type="text" id="unitAdmin" name="unitAdmin" v-validate="'required'" key="unitAdmin-input" v-model="dormitoryApply.unitAdmin" class="form-control" maxlength="10"/>
										<span class="text-danger" v-show="errors.has('unitAdmin')">{{ errors.first('unitAdmin') }}</span>
									</label>

								</div>
							</div>
							<div class="row form-group">
								<div class="col-md-12 form-group">
									<label class="col-xs-6 col-md-3 column-required">{{unitSuperTitle}}</label>
									<label class="col-xs-6 col-md-3" v-if="$route.name == 'stay.apply.view'">
										{{ dormitoryApply.unitSuper }}
									</label>
									<label class="col-xs-6 col-md-3" v-else>
										<input type="text" id="unitSuper" name="unitSuper" key="unitSuper-input" v-validate="'required'" v-model="dormitoryApply.unitSuper" class="form-control" maxlength="10"/>
										<span class="text-danger" v-show="errors.has('unitSuper')">{{ errors.first('unitSuper') }}</span>
									</label>

								</div>
							</div>
							<div class="row form-group" v-if="dormitoryApply.roomReason == 9">
								<div class="col-md-12 form-group">
									<label class="col-xs-6 col-md-3 column-required">上傳檔案(限pdf)：</label>
									<label class="col-xs-6 col-md-3" for="proveFileFile" v-if="$route.name != 'stay.apply.view'">
										<div style="display:none;">
											<input type="file" id="proveFileFile" style="width: 100%" accept=".pdf" key="proveFile-file" ref="proveFile" @change="getProveFile($event)" />
											<input type="hidden" name="proveFile" v-model="dormitoryApply.proveFile" key="proveFile-input" v-validate="'required'" value="" />
										</div>
										<a class="btn btn-default">請選擇檔案</a>
										<span class="text-danger" v-show="errors.has('proveFile')">{{ errors.first('proveFile') }}</span>
									</label>
									<p>
										{{dormitoryApply.proveFile}}
										<a v-if="proveFilePreviewPDF" :href="proveFilePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
									</p>
								</div>
							</div>
							<div class="row form-group" v-if="dormitoryApply.roomReason == 9">
								<div class="col-md-12 form-group">
									<label class="col-xs-6 col-md-3 column-required">請　簡　述　　 ：</label>
									<label class="col-xs-6 col-md-9" v-if="$route.name == 'stay.apply.view'">
										{{ dormitoryApply.briefDesc }}
									</label>
									<label class="col-xs-6 col-md-9" v-else>
										<input type="text" id="briefDesc" name="briefDesc" v-validate="'required|max:99'" key="briefDesc-input" v-model="dormitoryApply.briefDesc" class="form-control" />
										<span class="text-danger" v-show="errors.has('briefDesc')">{{ errors.first('briefDesc') }}</span>
									</label>

								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 form-group" v-if="$route.name != 'stay.apply.view'">
							<header>
								<h5>住宿規定</h5>
							</header>
							<p>
								1. 住宿期間為
								<datepicker name="roomBeginDate" :format="customFormatter" v-validate="'required'" :language="zh" v-model="roomBeginDate"  input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomBeginDate`)">
								</datepicker>
								<span class="text-danger" v-show="errors.has('roomBeginDate')">{{ errors.first('roomBeginDate') }}</span>
								　至　
								<datepicker name="roomEndDate" :format="customFormatter" v-validate="'required'" :disabled-dates="endState.disabledDates" :language="zh" v-model="roomEndDate" input-class="form-control" placeholder="結束日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomEndDate`)">
								</datepicker>
								<span class="text-danger" v-show="errors.has('roomEndDate')">{{ errors.first('roomEndDate') }}</span>
								　止(共計{{sumRoomDay}}天)。(依住宿同學需求訂之)
							</p>
							<p>2. 申請同學原則安排於高爾夫、香檳住宿，以便於照應管理，實際住宿地點依生輔組公告為主</p>
							<p>3. 住宿同學負責打掃宿舍環境，包含廁所、盥洗室、廚房、陽台等公共區域，並輪值傾倒垃圾；住宿期間水、電、瓦斯、網路費另需自付。</p>
							<p>4. 凡寒暑假期間違反住宿規定者，一律以退宿辦理，並不得要求退還住宿費。</p>
							<p>5. 申請住宿須附家長同意書、師長證明書及身分證正反面影本黏貼於背面，始得住宿。</p>
							<p>6. 本申請案將以專案上簽，僅適用於在校相關學習與工讀等事物之同學申請，非與學校相關之學習與工讀同學不得申請。</p>
							<p>7. 申請人均同意本住宿規定並遵守，如有違犯依規定辦理。
								<label>
									<span :style="{color:'#FF0000'}">本人同意以上住宿規定並遵守 </span> 請打勾
									<input type="checkbox" name="isCheckBoxOk" v-model="isCheckBoxOk" v-validate="'required'" />
									<span class="text-danger" v-show="errors.has('isCheckBoxOk')">{{ errors.first('isCheckBoxOk') }}</span>
								</label>
							</p>
						</div>
						<div class="col-md-12 form-group" v-else>
							<header>
								<h5>住宿規定</h5>
							</header>
              <p v-if="!dormitoryApply.bankBarcode1">
                1. 住宿期間為
                <datepicker name="roomBeginDate" :format="customFormatter" v-validate="'required'" :language="zh" v-model="roomBeginDate"  input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomBeginDate`)">
                </datepicker>
                <span class="text-danger" v-show="errors.has('roomBeginDate')">{{ errors.first('roomBeginDate') }}</span>
                　至　
                <datepicker name="roomEndDate" :format="customFormatter" v-validate="'required'" :disabled-dates="endState.disabledDates" :language="zh" v-model="roomEndDate" input-class="form-control" placeholder="結束日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomEndDate`)">
                </datepicker>
                <span class="text-danger" v-show="errors.has('roomEndDate')">{{ errors.first('roomEndDate') }}</span>
                　止(共計{{sumRoomDay}}天)。(依住宿同學需求訂之)
              </p>
              <p v-else> 1. 住宿期間為 {{!!dormitoryApply.roomBeginDateCht ? dormitoryApply.roomBeginDateCht : customFormatter(dormitoryApply.roomBeginDate)}}
                至{{!!dormitoryApply.roomEndDateCht ? dormitoryApply.roomEndDateCht : customFormatter(dormitoryApply.roomEndDate)}} 止(共計 {{sumRoomDay}} 天)。(依住宿同學需求訂之) </p>
						</div>

						<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">家長證明書：</label>
							<label class="col-xs-6 col-md-3" for="parentProveFile" v-if="$route.name != 'stay.apply.view'">
								<div style="display:none;">
									<input type="file" id="parentProveFile" style="width: 100%" accept=".pdf,image/*" ref="parentProve" @change="getParentProve($event)" />
									<input type="hidden" name="parentProve" v-model="dormitoryApply.parentProve" v-validate="'required'" value="" />
								</div>
								<a class="btn btn-default">請選擇檔案</a>
								<span class="text-danger" v-show="errors.has('parentProve')">{{ errors.first('parentProve') }}</span>
							</label>
							<p>
								{{dormitoryApply.parentProve}}
								<a v-if="parentProvePreviewPDF" :href="parentProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
							</p>
						</div>
						<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="parentProvePreview">
							<a :href="parentProvePreview" target="_blank">
								<img class="img-fluid" :src="parentProvePreview" alt="" style="width:200px; "/>
							</a>
						</div>
						<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">師長證明書：</label>
							<label class="col-xs-6 col-md-3" for="teacherProveFile" v-if="$route.name != 'stay.apply.view'">
								<div style="display:none;">
									<input type="file" id="teacherProveFile" style="width: 100%" accept=".pdf,image/*" ref="teacherProve" name="teacherProve" @change="getTeacherProve($event)" />
									<input type="hidden" name="teacherProve" v-model="dormitoryApply.teacherProve" v-validate="'required'" value="" />
								</div>
								<a class="btn btn-default">請選擇檔案</a>
								<span class="text-danger" v-show="errors.has('teacherProve')">{{ errors.first('teacherProve') }}</span>
							</label>
							<p>
								{{dormitoryApply.teacherProve}}
								<a v-if="teacherProvePreviewPDF" :href="teacherProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
							</p>
						</div>
						<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="teacherProvePreview">
							<a :href="teacherProvePreview" target="_blank">
								<img class="img-fluid" :src="teacherProvePreview" alt="" style="width:200px; "/>
							</a>
						</div>
						<div class="col-md-12 form-group">
							<p>繳費金額；單天以$150元計，於入宿前至出納繳交並將收據正本繳回生輔組，總金額為 {{sumRoomAmt}} 元整。</p>
						</div>
					</div>
				</div>
				<div v-else-if="dormitoryApply.dormitoryType == 'S'">
					<div class="row form-group">
						<div class="col-md-12 form-group" v-if="$route.name != 'stay.apply.view'">
							<header>
								<h5>申請資料如下</h5>
							</header>
							<p>
								1. 住宿期間為
								<datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="roomBeginDate"  input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomBeginDate`)"/>
								<span class="text-danger" v-show="errors.has('roomBeginDate')">{{ errors.first('roomBeginDate') }}</span>
								至　
								<datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="roomEndDate" :disabled-dates="endState.disabledDates" input-class="form-control" placeholder="結束日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomEndDate`)"/>
								<span class="text-danger" v-show="errors.has('roomEndDate')">{{ errors.first('roomEndDate') }}</span>
								　止(共計{{sumRoomDay}}天)。
							</p>
							<p>
								2. 申請人均同意本住宿規定並遵守，如有違犯依規定辦理。
								<label>
									<span :style="{color:'#FF0000'}">本人同意以上住宿規定並遵守</span>
									請打勾 <input type="checkbox" v-validate="'required'" name="isCheckBoxOk" v-model="isCheckBoxOk" />
									<span class="text-danger" v-show="errors.has('isCheckBoxOk')">{{ errors.first('isCheckBoxOk') }}</span>
								</label>
							</p>
						</div>
						<div class="col-md-12 form-group" v-else>
							<header>
								<h5>申請資料如下</h5>
							</header>
              <p v-if="!dormitoryApply.bankBarcode1">
                1. 住宿期間為
                <datepicker name="roomBeginDate" :format="customFormatter" v-validate="'required'" :language="zh" v-model="roomBeginDate"  input-class="form-control" placeholder="開始日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomBeginDate`)">
                </datepicker>
                <span class="text-danger" v-show="errors.has('roomBeginDate')">{{ errors.first('roomBeginDate') }}</span>
                　至　
                <datepicker name="roomEndDate" :format="customFormatter" v-validate="'required'" :disabled-dates="endState.disabledDates" :language="zh" v-model="roomEndDate" input-class="form-control" placeholder="結束日期" :style="{width:'auto', display:'inline-block'}" @closed="sumDaysAndAmt(`roomEndDate`)">
                </datepicker>
                <span class="text-danger" v-show="errors.has('roomEndDate')">{{ errors.first('roomEndDate') }}</span>
                　止(共計{{sumRoomDay}}天)。(依住宿同學需求訂之)
              </p>
              <p v-else> 1. 住宿期間為 {{!!dormitoryApply.roomBeginDateCht ? dormitoryApply.roomBeginDateCht : customFormatter(dormitoryApply.roomBeginDate)}}
                至{{!!dormitoryApply.roomEndDateCht ? dormitoryApply.roomEndDateCht : customFormatter(dormitoryApply.roomEndDate)}} 止(共計 {{sumRoomDay}} 天)。(依住宿同學需求訂之) </p>
						</div>
						<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">家長證明書：</label>
							<label class="col-xs-6 col-md-3" for="parentProveFile" v-if="$route.name != 'stay.apply.view'">
								<div style="display:none;">
									<input type="file" id="parentProveFile" style="width: 100%" accept=".pdf,image/*" ref="parentProve" @change="getParentProve($event)" />
									<input type="hidden" name="parentProve" v-model="dormitoryApply.parentProve" v-validate="'required'" value="" />
								</div>
								<a class="btn btn-default">請選擇檔案</a>
								<span class="text-danger" v-show="errors.has('parentProve')">{{ errors.first('parentProve') }}</span>
							</label>
							<p>
								{{dormitoryApply.parentProve}}
								<a v-if="parentProvePreviewPDF" :href="parentProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
							</p>
						</div>
						<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="parentProvePreview">
							<a :href="parentProvePreview" target="_blank">
								<img class="img-fluid" :src="parentProvePreview" alt="" style="width:200px; "/>
							</a>
						</div>
						<div class="col-md-12 form-group">
							<label class="col-xs-6 col-md-3 column-required">師長證明書：</label>
							<label class="col-xs-6 col-md-3" for="teacherProveFile" v-if="$route.name != 'stay.apply.view'">
								<div style="display:none;">
									<input type="file" id="teacherProveFile" style="width: 100%" accept=".pdf,image/*" ref="teacherProve" name="teacherProve" @change="getTeacherProve($event)" />
									<input type="hidden" name="teacherProve" v-model="dormitoryApply.teacherProve" v-validate="'required'" value="" />
								</div>
								<a class="btn btn-default">請選擇檔案</a>
								<span class="text-danger" v-show="errors.has('teacherProve')">{{ errors.first('teacherProve') }}</span>
							</label>
							<p>
								{{dormitoryApply.teacherProve}}
								<a v-if="teacherProvePreviewPDF" :href="teacherProvePreviewPDF" style="color: #337ab7" target="_blank">檔案預覽</a>
							</p>
						</div>
						<div class="col-xs-offset-util-3 col-xs-6 col-md-offset-util-3 col-md-6" v-if="teacherProvePreview">
							<a :href="teacherProvePreview" target="_blank">
								<img class="img-fluid" :src="teacherProvePreview" alt="" style="width:200px; "/>
							</a>
						</div>
						<div class="col-md-12 form-group">
							<p>住宿天數、費用（以實際公告住宿金額除以18週計算），總金額為 {{sumRoomAmt}} 元整。</p>
						</div>
					</div>
				</div>
				<div v-if="$route.name == 'stay.apply.view'">
					<div class="row form-group">
						<div class="col-md-12">
							<hr/>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group">
							<label class="col-xs-12 col-md-u column-required">生活問卷：</label>
							<label><a @click="showPopup = true; isPopDisable=true;" class="btn btn-link">檢視</a></label>
						</div>
            <div class="col-md-12 form-group">
              <label class="col-xs-12 col-md-12">隱私權及個人資料保護政策宣告：{{ (customFormatter(dormitoryApply.crDate, "YYYY")-1911) + customFormatter(dormitoryApply.crDate, "年MM月DD日") }} 第{{ !!dormitoryApply.privacyTreatyVersion ? dormitoryApply.privacyTreatyVersion : "1.0" }}版</label>
            </div>
            <div class="col-md-12 form-group">
              <label class="col-xs-12 col-md-12">亞東學校財團法人亞東科技大學學生住宿輔導及管理規定：{{ (customFormatter(dormitoryApply.crDate, "YYYY")-1911) + customFormatter(dormitoryApply.crDate, "年MM月DD日") }}</label>
            </div>
            <div class="col-md-12 form-group">
              <label class="col-xs-12 col-md-12">亞東學校財團法人亞東科技大學學生宿舍生活公約：{{ (customFormatter(dormitoryApply.crDate, "YYYY")-1911) + customFormatter(dormitoryApply.crDate, "年MM月DD日") }}</label>
            </div>
						<div class="col-md-12 form-group">
							<label class="col-xs-12 col-md-u column-required">審核狀態：</label>
							<label class="radio-inline" v-for="(item, index) in apysList" :key="index" :for="'apysList_'+index">
								<input :id="'apysList_'+index" name="applyStatus" type="radio" :value="item.commCode" v-model="dormitoryApply.applyStatus" :disabled="dormitoryApply.bankBarcode1"/> {{item.commValue}}
							</label>
						</div>
						<div class="col-md-12 form-group" v-if="this.dormitoryApply.applyStatus ==='Y'">
							<label class="col-xs-12 col-md-u column-required">錄取狀態：</label>
							<label class="radio-inline" v-for="(item, index) in qualifList" :key="index" :for="'qualification_'+index">
								<input :id="'qualification_'+index" name="qualification" type="radio" :value="item.commCode" v-model="dormitoryApply.qualification" :disabled="dormitoryApply.bankBarcode1"/> {{item.commValue}}
							</label>
						</div>
						<div class="col-xs-12 col-md-12 form-group">
							<div class="col-md-2 form-group" >
								<button type="button" class="btn btn-primary btn-block" @click="showOpinionPopControl(true)" v-if="!dormitoryApply.bankBarcode1">審查意見樣本</button>
							</div>
							<div class="col-xs-12 col-md-12 form-group" style="margin-bottom: 15px; padding-left: 15px !important; padding-right: 15px !important;">
								<textarea class="form-control" rows="5" name="reviewOpinion" v-model="dormitoryApply.reviewOpinion" maxlength="1000" :disabled="dormitoryApply.bankBarcode1"></textarea>
							</div>
						</div>
					</div>
					<div class="row form-group" v-if="!dormitoryApply.bankBarcode1">
						<div class="col-md-2 col-md-offset-3 form-group">
							<a @click="clickPrevious" class="btn s_btn_g btn-block">返回</a>
						</div>
						<div class="col-md-2 form-group">
						</div>
						<div class="col-md-2 form-group">
							<a @click="saveEvent" class="btn btn-primary btn-block">儲存</a>
						</div>
					</div>
					<div class="row form-group" v-else>
						<div class="col-md-2 col-md-offset-5 form-group">
							<a @click="clickPrevious" class="btn s_btn_g btn-block">返回</a>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="row form-group">
						<div class="col-md-2 col-md-offset-4 form-group">
							<a @click="clearFunc" class="btn s_btn_g btn-block">重填</a>
						</div>
						<div class="col-md-2 form-group">
							<a @click="showPopupControl(true)" class="btn btn-primary btn-block">下一步</a>
						</div>
					</div>
				</div>
				<questionPopup v-if="showPopup" v-bind:foodType="this.dormitoryApply.foodType" v-bind:stepTime="this.dormitoryApply.stepTime" v-bind:isSmoke="this.dormitoryApply.isSmoke" v-bind:cleanDay="this.dormitoryApply.cleanDay" v-bind:netUseTime="this.dormitoryApply.netUseTime" v-bind:otherRequest="this.dormitoryApply.otherRequest" v-bind:isShow="this.isPopDisable"/>
			</div>
		</section>
		<section class="panel" v-if="showView == 'treaty'">
			<treaty :key="$route.fullPath"></treaty>
		</section>
		<sampleOpinionPopup v-if="showOpinionPop"/>
	</div>
</template>
<script>
import treaty from './treaty';
import questionPopup from './lifeQuestion.vue';
import sampleOpinionPopup from './sampleOpinion.vue';
export default {
	props: ['showType'],
	components:{
		treaty,
		questionPopup,
		sampleOpinionPopup
	},
	data(){
		return {
			title:"",
			applyInfoParams:{},
			stuBase:{
				idno:"",
				name:"",
				natnName:"",
				sex:"",
				sexStr:"",
				account:"",
				birthDay:"",
				ssymCode:"",
				deptCode:"",
				deptSsymStr:"",
				deptCodeStr:"",
				drade:"",
				dradeClass:"",
				tel:"",
				phone:"",
				extMail:"",
				schMail:"",
				parentName:"",
				kinship:"",
				parentPhone:"",
				resiCityId:"",
				resiCityStr:"",
				resiAreaId:"",
				resiAreaStr:"",
				resiAddr:"",
				mailCityId:"",
				mailCityStr:"",
				mailAreaId:"",
				mailAreaStr:"",
				mailAddr:"",
				idCardPosit:"",
				idCardRever:"",
			},
			dormitoryApply:{
				id:"",
				smtr:"",
				idno:"",
				account:"",
				diseaseHis:"",
				dormitoryType:"N",
				stuIdentity:"",
				isStuLoan:"",
				stuLoanProve:"",
				stuPhoto:"",
				household:"",
				passport:"",
				resident:"",
				lowIncomeProve:"",
				specialProve:"",
				roomReason:"",
				unitAdmin:"",
				unitSuper:"",
				proveFile:"",
				briefDesc:"",
				roomBeginDate:"",
				roomBeginDateCht:"",
				roomEndDate:"",
				roomEndDateCht:"",
				parentProve:"",
				teacherProve:"",
				foodType:"",
				stepTime:"",
				netUseTime:"",
				isSmoke:"",
				cleanDay:"",
				otherRequest:""
			},
			stuIsExists:false,
			ssym:"",
			dept:"",
			identical: false,
			diseaseHisArray:[],
			diseaseHisOther:"",
			stuLoanProveFile:null,
			stuLoanProvePreview:null,
			stuLoanProvePreviewPDF:"",
			stuPhotoFile:null,
			stuPhotoPreview:null,
			stuPhotoPreviewPDF:"",
			idCardPositFile:null,
			idCardPositPreview:null,
			idCardPositPreviewPDF:"",
			idCardReverFile:null,
			idCardReverPreview:null,
			idCardReverPreviewPDF:"",
			householdFile:null,
			householdPreview:null,
			householdPreviewPDF:"",
			passportFile:null,
			passportPreview:null,
			passportPreviewPDF:"",
			residentFile:null,
			residentPreview:null,
			residentPreviewPDF:"",
			lowIncomeProveFile:null,
			lowIncomeProvePreview:null,
			lowIncomeProvePreviewPDF:"",
			specialProveFile:null,
			specialProvePreview:null,
			specialProvePreviewPDF:"",
			isCheckBoxOk: false,
			proveFileFile:null,
			proveFilePreviewPDF:"",
			parentProveFile:null,
			parentProvePreview:null,
			parentProvePreviewPDF:"",
			teacherProveFile:null,
			teacherProvePreview:null,
			teacherProvePreviewPDF:"",
			roomBeginDate: "",
			roomEndDate: "",
			ssymList:[],
			deptList:[],
			selectDeptList:[],
			resiCityList:[],
			resiAreaList:[],
			mailCityList:[],
			mailAreaList:[],
			diseaseList:[],
			roomRsList:[],
			identiList:[],
			countryList:[
				{ name:"越南", officialName:"越南社會主義共和國", isoCode:"VN", dialCode:"84" },
				{ name:"印尼", officialName:"印度尼西亞共和國", isoCode:"ID", dialCode:"62" },
				{ name:"泰國", officialName:"泰國王國", isoCode:"TH", dialCode:"66" },
				{ name:"緬甸", officialName:"緬甸聯邦共和國", isoCode:"MM", dialCode:"95" },
				{ name:"菲律賓", officialName:"菲律賓共和國", isoCode:"PH", dialCode:"63" },
				{ name:"柬埔寨", officialName:"柬埔寨王國", isoCode:"KH", dialCode:"855" },
				{ name:"馬來西亞", officialName:"馬來西亞", isoCode:"MY", dialCode:"60" },
				{ name:"巴西", officialName:"巴西聯邦共和國", isoCode:"BR", dialCode:"55" },
				{ name:"日本", officialName:"日本國", isoCode:"JP", dialCode:"81" },
				{ name:"加拿大", officialName:"加拿大", isoCode:"CA", dialCode:"1" },
				{ name:"史瓦帝尼", officialName:"史瓦帝尼王國", isoCode:"SZ", dialCode:"268" },
				{ name:"孟加拉", officialName:"孟加拉人民共和國", isoCode:"BD", dialCode:"880" },
				{ name:"香港", officialName:"中華人民共和國香港特別行政區", isoCode:"HK", dialCode:"852" },
			],
			stuIdentity:"",
			showPopup:false,
			showOpinionPop:false,
			isPopDisable:false,
			storeData:{},
			sumRoomDay:0,
			sumRoomAmt:0,
			apysList:[],
			qualifList:[],
			sampleOpinionList:[],
			showView: "",
			beginState:{
				disabledDates:{
					to: new Date()
				}
			},
			endState:{
				disabledDates:{
					to: new Date()
				}
			},
			birthState:{
				disabledDates:{
					from: new Date()
				}
			}
		}

	},
	mounted(){
		if(this.$route.name == "stay.apply.view" || this.$route.name == "stay.apply.edit"){
			this.showView = "";
		}else{
			this.showView = "treaty";
		}
		this.editInit();
	},
	methods:{
		editInit(){
			if (this.getStore(this.$route.name) != null) {
				this.storeData = JSON.parse(this.getStore(this.$route.name));
				this.dormitoryApply.smtr = this.storeData.smtr;
				this.dormitoryApply.dormitoryType = this.storeData.dormitoryType;
				if(this.$route.name == "stay.apply.edit"){
					if (this.dormitoryApply.dormitoryType == "V") {
						this.title = "寒暑假宿舍申請表";
					} else if (this.dormitoryApply.dormitoryType == "S") {
						this.title = "特殊原因宿舍申請表";
					} else {
						this.title = "宿舍申請表";
					}
					if(this.isLogin && this.sessionData.accountType == "STU"){
						this.applyInfoParams={
							account : this.sessionData.account,
							smtr : this.dormitoryApply.smtr,
							dormitoryType : this.dormitoryApply.dormitoryType,
							id : this.storeData.id,
						};
					}else if(!this.isLogin){
                        this.applyInfoParams={
                            account : this.storeData.account,
                            smtr : this.storeData.smtr,
							dormitoryType : this.storeData.dormitoryType,
                            id : this.storeData.id,
                        };
                    }

				}else{
					this.applyInfoParams={
						account : this.storeData.account,
						id : this.storeData.id,
					};
				}
			}else if(this.$route.name == "stay.apply.new"){
				this.dormitoryApply.dormitoryType = "N";
			}
			const AppluInitData = async () => {
				const api = `/api/Room/applyInit/${this.dormitoryApply.dormitoryType}`;
				return await this.$axios.post(api);
			}
			Promise.resolve(AppluInitData()).then(resp => {
				if(resp.data.status == "success"){
					this.diseaseList = resp.data.data.diseaseList;
					this.identiList = resp.data.data.identiList;
					this.roomRsList = resp.data.data.roomRsList;
					this.ssymList = resp.data.data.ssymList;
					this.resiCityList = resp.data.data.cityList;
					this.mailCityList = resp.data.data.cityList;
					this.deptList = resp.data.data.deptList;
					this.qualifList = resp.data.data.qualifList;
					this.apysList = resp.data.data.apysList;
				}else{
					bootbox.alert(resp.data.msg, function(){
						window.location.href="/";
					});
				}
				if(this.applyInfoParams.account){
					this.getRoomApplyInfo();
				}
			});
		},
		getResiArea() {
			this.stuBase.resiAreaId = "";
			this.stuBase.resiRoadId = "";
			this.stuBase.resiAreaList = [];
			this.stuBase.resiRoadList = [];
			const api = `/api/Common/getArea/${this.stuBase.resiCityId}`;
			const f = async () => {
				return await this.$axios.post(api);
			};
			Promise.resolve(f()).then(resp =>{
				if(resp.data.status == "success"){
					this.resiAreaList = resp.data.data.areaList;
				}
			});
		},
		getMailArea() {
			this.stuBase.mailAreaId = "";
			this.mailAreaList = [];
			const api = `/api/Common/getArea/${this.stuBase.mailCityId}`;
			const f = async () =>{
				return await this.$axios.post(api);
			};
			Promise.resolve(f()).then(resp =>{
				if(resp.data.status == "success"){
					this.mailAreaList = resp.data.data.areaList
				}
			});
		},
		getRoomApplyInfo() {
			let _this = this;
			const roomInfoData = async () => {
				const api = "/api/Room/roomInfo/";
				return await this.$axios.post(api, this.applyInfoParams);
			}
			Promise.resolve(roomInfoData()).then(resp => {
				if(resp.data.status !== "success"){
					bootbox.alert(resp.data.msg, function(){
						_this.$router.go(-1);
					});
				}else{
					if(resp.data.data){
						if("stuBase" in resp.data.data && resp.data.data.stuBase){
							this.stuBase = resp.data.data.stuBase;
							this.stuIsExists = true;
							this.syncForeignCountryData();

							if(this.stuBase.mailAreaId){
								this.mailAreaList = [];
								const areaData = async ()=> {
									const api = "/api/Common/getArea/" + this.stuBase.mailCityId;
									return await this.$axios.post(api);
								}
								Promise.resolve(areaData()).then(r => {
									if(r.data.status == "success"){
										this.mailAreaList = r.data.data.areaList
									}
								});
							}
						}
						if("dormitoryApply" in resp.data.data && resp.data.data.dormitoryApply){
							this.dormitoryApply = resp.data.data.dormitoryApply;
							if(this.dormitoryApply.roomBeginDate){
								this.roomBeginDate = new Date(this.dormitoryApply.roomBeginDate);
							}
							if(this.dormitoryApply.roomEndDate){
								this.roomEndDate = new Date(this.dormitoryApply.roomEndDate);
							}
							if(this.$route.name != "stay.apply.view"){
								if(this.dormitoryApply.applyStatus && this.dormitoryApply.applyStatus != "R"){

								}
							}
							let diseaseHisJson = JSON.parse(this.dormitoryApply.diseaseHis);
							for (let k in diseaseHisJson){
								if (k === '9' && diseaseHisJson[k] !== 'N') {
									this.diseaseHisArray.push(k)
									this.diseaseHisOther = diseaseHisJson[k]
								} else if (diseaseHisJson[k] === 'Y') {
									this.diseaseHisArray.push(k)
								}
							}

							if(this.dormitoryApply.proveFile){
								this.proveFilePreviewPDF = "/upload/" + this.dormitoryApply.proveFile
							}

							if (this.dormitoryApply.stuPhoto) {
								if (this.dormitoryApply.stuPhoto.split(".")[1] === 'pdf') {
									this.stuPhotoPreviewPDF = "/upload/" + this.dormitoryApply.stuPhoto
								} else {
									this.stuPhotoPreview = "/upload/" + this.dormitoryApply.stuPhoto
								}
							}

							if (this.stuBase.idCardPosit) {
								if (this.stuBase.idCardPosit.split(".")[1] === 'pdf') {
									this.idCardPositPreviewPDF = "/upload/" + this.stuBase.idCardPosit
								} else {
									this.idCardPositPreview = "/upload/" + this.stuBase.idCardPosit
								}
							}

							if (this.stuBase.idCardRever) {
								if (this.stuBase.idCardRever.split(".")[1] === 'pdf') {
									this.idCardReverPreviewPDF = "/upload/" + this.stuBase.idCardRever
								} else {
									this.idCardReverPreview = "/upload/" + this.stuBase.idCardRever
								}
							}

							if (this.dormitoryApply.household) {
								if (this.dormitoryApply.household.split(".")[1] === 'pdf') {
									this.householdPreviewPDF = "/upload/" + this.dormitoryApply.household
								} else {
									this.householdPreview = "/upload/" + this.dormitoryApply.household
								}
							}

							if (this.dormitoryApply.parentProve) {
								if (this.dormitoryApply.parentProve.split(".")[1] === 'pdf') {
									this.parentProvePreviewPDF = "/upload/" + this.dormitoryApply.parentProve
								} else {
									this.parentProvePreview = "/upload/" + this.dormitoryApply.parentProve
								}
							}

							if (this.dormitoryApply.teacherProve) {
								if (this.dormitoryApply.teacherProve.split(".")[1] === 'pdf') {
									this.teacherProvePreviewPDF = "/upload/" + this.dormitoryApply.teacherProve
								} else {
									this.teacherProvePreview = "/upload/" + this.dormitoryApply.teacherProve
								}
							}

							if (this.dormitoryApply.lowIncomeProve) {
								if (this.dormitoryApply.lowIncomeProve.split(".")[1] === 'pdf') {
									this.lowIncomeProvePreviewPDF = "/upload/" + this.dormitoryApply.lowIncomeProve
								} else {
									this.lowIncomeProvePreview = "/upload/" + this.dormitoryApply.lowIncomeProve
								}
							}

							if (this.dormitoryApply.passport) {
								if (this.dormitoryApply.passport.split(".")[1] === 'pdf') {
									this.passportPreviewPDF = "/upload/" + this.dormitoryApply.passport
								} else {
									this.passportPreview = "/upload/" + this.dormitoryApply.passport
								}
							}

							if (this.dormitoryApply.resident) {
								if (this.dormitoryApply.resident.split(".")[1] === 'pdf') {
									this.residentPreviewPDF = "/upload/" + this.dormitoryApply.resident
								} else {
									this.residentPreview = "/upload/" + this.dormitoryApply.resident
								}
							}

							if (this.dormitoryApply.specialProve) {
								if (this.dormitoryApply.specialProve.split(".")[1] === 'pdf') {
									this.specialProvePreviewPDF = "/upload/" + this.dormitoryApply.specialProve
								} else {
									this.specialProvePreview = "/upload/" + this.dormitoryApply.specialProve
								}
							}

							if (this.dormitoryApply.stuLoanProve) {
								if (this.dormitoryApply.stuLoanProve.split(".")[1] === 'pdf') {
									this.stuLoanProvePreviewPDF = "/upload/" + this.dormitoryApply.stuLoanProve
								} else {
									this.stuLoanProvePreview = "/upload/" + this.dormitoryApply.stuLoanProve
								}
							}
							this.syncForeignCountryData();
							this.sumDaysAndAmt();
						}
					}
				}
			});
		},
		getCountryOption(countryName) {
			return this.countryList.find(item => item.name === countryName || item.officialName === countryName || item.isoCode === countryName);
		},
		syncForeignCountryData() {
			if (!this.isForeignStudent) {
				return;
			}
			const country = this.getCountryOption(this.stuBase.natnName);
			if (country) {
				this.stuBase.natnName = country.name;
				this.stuBase.tel = country.dialCode;
			}
		},
		changeCountry() {
			if (!this.isForeignStudent) {
				return;
			}
			const country = this.getCountryOption(this.stuBase.natnName);
			this.stuBase.tel = country ? country.dialCode : "";
		},
		changeDataGetStuBase() {
			if (this.isForeignStudent || !this.stuBase.idno) {
				return;
			}
			if (this.stuBase.idno) {
				const api = `/api/Room/studIsExists/${this.stuBase.idno}?dormitoryType=${this.dormitoryApply.dormitoryType}`;
				const _this = this;
				this.$axios.post(api).then(resp=>{
					if(resp.data.status != "success"){
						bootbox.alert(resp.data.msg, function(){
							_this.$router.replace({ name: "index" });
						});
					}else{
						_this.getRoomApplyInfo();
					}
				});

			}
		},
		copyAddr(e){
			if(e.target.checked == true){
				if (this.isForeignStudent) {
					this.stuBase.mailAreaId = ""
					this.stuBase.mailCityId = ""
				} else {
					this.mailAreaList = this.resiAreaList
					this.stuBase.mailAreaId = this.stuBase.resiAreaId
					this.stuBase.mailCityId = this.stuBase.resiCityId
				}
				this.stuBase.mailAddr = this.stuBase.resiAddr
			}else{
				this.mailAreaList = []
				this.stuBase.mailAreaId = ""
				this.stuBase.mailCityId = ""
				this.stuBase.mailAddr = ""
			}
		},
		chnageRoomReason() {
			this.dormitoryApply.unitAdmin = "";
			this.dormitoryApply.unitSuper = "";
			this.dormitoryApply.briefDesc = "";
			this.dormitoryApply.proveFile = "";
			this.proveFilePreviewPDF = null;
		},
		changeStuIdentity() {
			this.dormitoryApply.stuPhoto = "";
			this.stuBase.idCardPosit = "";
			this.stuBase.idCardRever = "";
			this.dormitoryApply.household = "";
			this.dormitoryApply.passport = "";
			this.dormitoryApply.resident = "";
			this.dormitoryApply.lowIncomeProve = "";
			this.dormitoryApply.specialProve = "";
			this.dormitoryApply.isStuLoan = this.isForeignStudent ? "N" : "";
			this.dormitoryApply.stuLoanProve = "";

			this.stuPhotoFile = null;
			this.idCardPositFile = null;
			this.idCardReverFile = null;
			this.householdFile = null;
			this.passportFile = null;
			this.residentFile = null;
			this.lowIncomeProveFile = null;
			this.specialProveFile = null;
			this.stuLoanProveFile = null;

			this.stuPhotoPreview = "";
			this.idCardPositPreview = "";
			this.idCardReverPreview = "";
			this.householdPreview = "";
			this.passportPreview = "";
			this.lowIncomeProvePreview = "";
			this.residentPreview = "";
			this.specialProvePreview = "";
			this.stuLoanProvePreview = "";

			this.stuPhotoPreviewPDF = null;
			this.idCardPositPreviewPDF = null;
			this.idCardReverPreviewPDF = null;
			this.householdPreviewPDF = null;
			this.passportPreviewPDF = null;
			this.lowIncomeProvePreviewPDF = null;
			this.residentPreviewPDF = null;
			this.specialProvePreviewPDF = null;
			this.stuLoanProvePreviewPDF = null;

			if (this.isForeignStudent) {
				this.stuBase.resiCityId = "";
				this.stuBase.resiAreaId = "";
				this.stuBase.mailCityId = "";
				this.stuBase.mailAreaId = "";
				this.changeCountry();
			} else {
				if (this.getCountryOption(this.stuBase.natnName)) {
					this.stuBase.natnName = "中華民國";
				}
				this.stuBase.tel = "";
			}
		},
		getStuLoanProve(event) {
			let self = this
			this.stuLoanProveFile = event.target.files[0];
			if(this.stuLoanProveFile){
				if(this.checkFileExtension(this.stuLoanProveFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.stuLoanProve = this.stuLoanProveFile.name;
					this.stuLoanProvePreview = null;
					this.imgPreview(event.target.files[0]).then(result =>{
						self.stuLoanProvePreview = result;
					}).catch(reason =>{
						self.stuLoanProveFile = null;
						self.dormitoryApply.stuLoanProve = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.stuLoanProveFile.type)){
						this.compresImage(this.stuLoanProveFile).then(result => {
							this.stuLoanProveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.stuLoanProveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}
		},
		getStuPhoto(event) {
			let self = this;
			this.stuPhotoFile = event.target.files[0];
			if(this.stuPhotoFile){
				if(this.checkFileExtension(this.stuPhotoFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.stuPhoto = this.stuPhotoFile.name;
					this.stuPhotoPreview = null;
					this.imgPreview(event.target.files[0]).then(result=>{
						self.stuPhotoPreview = result;
					}).catch(reason =>{
						self.stuPhotoFile = null;
						self.dormitoryApply.stuPhoto = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.stuPhotoFile.type)){
						this.compresImage(this.stuPhotoFile).then(result => {
							this.stuPhotoFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.stuPhotoFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getIdCardPosit(event) {
			let self = this
			this.idCardPositFile = event.target.files[0];
			if(this.idCardPositFile){
				if(this.checkFileExtension(this.idCardPositFile.name, ["jpg","jpeg","png","pdf"])){
					this.stuBase.idCardPosit = this.idCardPositFile.name;
					this.idCardPositPreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.idCardPositPreview = result;
					}).catch(reason =>{
						self.idCardPositFile = null;
						self.dormitoryApply.idCardPosit = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.idCardPositFile.type)){
						this.compresImage(this.idCardPositFile).then(result => {
							this.idCardPositFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.idCardPositFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getIdCardRever(event) {
			let self = this
			this.idCardReverFile = event.target.files[0];
			if(this.idCardReverFile){
				if(this.checkFileExtension(this.idCardReverFile.name, ["jpg","jpeg","png","pdf"])){
					this.stuBase.idCardRever = this.idCardReverFile.name;
					this.idCardReverPreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.idCardReverPreview = result;
					}).catch(reason =>{
						self.idCardReverFile = null;
						self.dormitoryApply.idCardRever = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.idCardReverFile.type)){
						this.compresImage(this.idCardReverFile).then(result => {
							this.idCardReverFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.idCardReverFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getHousehold(event) {
			let self = this
			this.householdFile = event.target.files[0];
			if(this.householdFile){
				if(this.checkFileExtension(this.householdFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.household = this.householdFile.name;
					this.householdPreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.householdPreview = result;
					}).catch(reason =>{
						self.householdFile = null;
						self.dormitoryApply.household = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.householdFile.type)){
						this.compresImage(this.householdFile).then(result => {
							this.householdFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.householdFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getPassPort(event) {
			let self = this
			this.passportFile = event.target.files[0];
			if(this.passportFile){
				if(this.checkFileExtension(this.passportFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.passport = this.passportFile.name;
					this.passportPreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.passportPreview = result;
					}).catch(reason =>{
						self.passportFile = null;
						self.dormitoryApply.passport = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.passportFile.type)){
						this.compresImage(this.passportFile).then(result => {
							this.passportFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.passportFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getResident(event) {
			let self = this
			this.residentFile = event.target.files[0];
			if(this.residentFile){
				if(this.checkFileExtension(this.residentFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.resident = this.residentFile.name;
					this.residentPreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.residentPreview = result;
					}).catch(reason =>{
						self.residentFile = null;
						self.dormitoryApply.resident = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.residentFile.type)){
						this.compresImage(this.residentFile).then(result => {
							this.residentFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.residentFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getLowIncomeProve(event) {
			let self = this
			this.lowIncomeProveFile = event.target.files[0];
			if(this.lowIncomeProveFile){
				if(this.checkFileExtension(this.lowIncomeProveFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.lowIncomeProve = this.lowIncomeProveFile.name;
					this.lowIncomeProvePreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.lowIncomeProvePreview = result;
					}).catch(reason =>{
						self.lowIncomeProveFile = null;
						self.dormitoryApply.lowIncomeProve = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.lowIncomeProveFile.type)){
						this.compresImage(this.lowIncomeProveFile).then(result => {
							this.lowIncomeProveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.lowIncomeProveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getSpecialProve(event) {
			let self = this
			this.specialProveFile = event.target.files[0];
			if(this.specialProveFile){
				if(this.checkFileExtension(this.specialProveFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.specialProve = this.specialProveFile.name;
					this.specialProvePreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.specialProvePreview = result;
					}).catch(reason =>{
						self.specialProveFile = null;
						self.dormitoryApply.specialProve = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.specialProveFile.type)){
						this.compresImage(this.specialProveFile).then(result => {
							this.specialProveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.specialProveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getProveFile(event) {
			this.proveFileFile = event.target.files[0]
			if(this.proveFileFile){
				this.dormitoryApply.proveFile = this.proveFileFile.name;
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}
		},
		getParentProve(event) {
			let self = this
			this.parentProveFile = event.target.files[0];
			if(this.parentProveFile){
				if(this.checkFileExtension(this.parentProveFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.parentProve = this.parentProveFile.name;
					this.parentProvePreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.parentProvePreview = result;
					}).catch(reason =>{
						self.parentProveFile = null;
						self.dormitoryApply.parentProve = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.parentProveFile.type)){
						this.compresImage(this.parentProveFile).then(result => {
							this.parentProveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.parentProveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getTeacherProve(event) {
			let self = this
			this.teacherProveFile = event.target.files[0];
			if(this.teacherProveFile){
				if(this.checkFileExtension(this.teacherProveFile.name, ["jpg","jpeg","png","pdf"])){
					this.dormitoryApply.teacherProve = this.teacherProveFile.name;
					this.teacherProvePreview = null;
					this.imgPreview(event.target.files[0]).then(result => {
						self.teacherProvePreview = result;
					}).catch(reason =>{
						self.teacherProveFile = null;
						self.dormitoryApply.teacherProve = "";
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.teacherProveFile.type)){
						this.compresImage(this.teacherProveFile).then(result => {
							this.teacherProveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.teacherProveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		showOpinionPopControl(isOpen){
			this.showOpinionPop = isOpen;
		},
		setOpinionValue(obj){
			this.dormitoryApply.reviewOpinion = obj;
			this.showOpinionPopControl(false);
		},
		showPopupControl(control) {
			if (control) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						// if (this.stuBase.idno.slice(1, 2) == 1 && this.stuBase.sex !== 'M') {
						// 	bootbox.alert("性別和身分證有誤")
						// 	return
						// } else if (this.stuBase.idno.slice(1, 2) == 2 && this.stuBase.sex !== 'F') {
						// 	bootbox.alert("性別和身分證有誤")
						// 	return
						// } else if (this.stuBase.idno.slice(1, 2) >= 3) {
						// 	bootbox.alert("身分證字號錯誤")
						// 	return
						// } else {
						// }
						this.showPopup = true;
					} else {
						const firstField = Object.keys(this.errors.collect())[0];
						document.getElementsByName(firstField)[0].scrollIntoView(false);
						bootbox.alert("請確認必填欄位是否有填寫");
					}
				});
			} else {
				this.showPopup = false;
			}
		},
		saveContorl(params) {
			let facilityJsonData = {};
			let diseaseHisArraySort = this.diseaseHisArray.sort()
			for (let i = 0; i < this.diseaseList.length; i++) {
				for (let j = 0; j <= i; j++) {
					if (diseaseHisArraySort[j] === this.diseaseList[i].commCode) {
						facilityJsonData[this.diseaseList[i].commCode] = "Y";
						if (this.diseaseList[i].commCode === "9") {
							facilityJsonData[this.diseaseList[i].commCode] = this.diseaseHisOther;
						}
						break
					}
					facilityJsonData[this.diseaseList[i].commCode] = "N";
				}
			}
			const api = "/api/Room/saveRoomApply";
			let formData = new FormData();
			this.stuBase.deptCode = this.ssym.toString() + this.dept.toString();
			this.stuBase.birthDay = this.customFormatter(this.stuBase.birthDay);
			if (this.isForeignStudent) {
				this.changeCountry();
				this.stuBase.resiCityId = "";
				this.stuBase.resiAreaId = "";
				this.stuBase.mailCityId = "";
				this.stuBase.mailAreaId = "";
				this.dormitoryApply.isStuLoan = "N";
				this.dormitoryApply.stuLoanProve = "";
			} else if (!this.stuBase.natnName) {
				this.stuBase.natnName = "中華民國";
			}
			this.dormitoryApply.smtr = this.storeData.smtr;
			if(this.$route.name == "stay.apply.new"){
				this.dormitoryApply.dormitoryType = "N";
			}else{
				this.dormitoryApply.dormitoryType = this.storeData.dormitoryType;
			}
			this.dormitoryApply.idno = this.stuBase.idno;
			this.dormitoryApply.account = this.stuBase.account;
			this.dormitoryApply.diseaseHis = JSON.stringify(facilityJsonData);
			if(this.dormitoryApply.dormitoryType !== "N"){
				this.dormitoryApply.roomBeginDate = this.roomBeginDate ? this.customFormatter(this.roomBeginDate) : "";
				this.dormitoryApply.roomEndDate = this.roomEndDate ? this.customFormatter(this.roomEndDate) : "";
			}
			this.dormitoryApply.foodType = params.foodType;
			this.dormitoryApply.stepTime = params.stepTime;
			this.dormitoryApply.isSmoke = params.isSmoke;
			this.dormitoryApply.cleanDay = params.cleanDay;
			this.dormitoryApply.netUseTime = params.netUseTime;
			this.dormitoryApply.otherRequest = params.otherRequest;

			if(this.dormitoryApply.applyStatus == "R"){
				this.dormitoryApply.applyStatus = "A";
			}
			for(let key in this.stuBase){
				if(this.stuBase[key]){
					formData.append("stuBase."+key,this.stuBase[key]);
				}
			}
			for(let key in this.dormitoryApply){
				if(this.dormitoryApply[key]){
					formData.append("dormitoryApply."+key,this.dormitoryApply[key]);
				}
			}

			formData.append("stuPhotoFile", this.stuPhotoFile);
			formData.append("idCardPositFile", this.idCardPositFile)
			formData.append("idCardReverFile", this.idCardReverFile)
			formData.append("householdFile", this.householdFile)
			formData.append("specialProveFile", this.specialProveFile)
			formData.append("stuLoanProveFile", this.stuLoanProveFile)
			formData.append("lowIncomeProveFile", this.lowIncomeProveFile)
			formData.append("passportFile", this.passportFile)
			formData.append("residentFile", this.residentFile)
			formData.append("parentProveFile", this.parentProveFile)
			formData.append("teacherProveFile", this.teacherProveFile)
			formData.append("proveFileFile", this.proveFileFile)
			let _this = this;
			this.$axios.post(api, formData).then(resp => {
				let status = resp.data.status;
				let msg = resp.data.msg;
				bootbox.alert(msg, function(){
					if (status === "success") {
						_this.$router.go(-1);
					}
				});
			});
		},
		clearFunc(){
			Object.assign(this.$data, this.$options.data());
			this.editInit()
		},
		sumDaysAndAmt(tagName){
			// if(tagName === 'roomBeginDate'){
			// 	this.endState.disabledDates.to = this.roomBeginDate;
			// }
			if(this.roomEndDate < this.roomBeginDate){
				bootbox.alert("住宿結束日期不可大於開始日期。");
				return false;
			}
			let day = Date.parse(this.customFormatter(this.roomEndDate)) - Date.parse(this.customFormatter(this.roomBeginDate))
			let comDay = day / (1000 * 60 * 60 * 24)
			if (!isNaN(comDay)){
				this.sumRoomDay = Math.floor(comDay);
				this.sumRoomAmt = this.sumRoomDay * 150;
			}
		},
		clickPrevious() {
			this.$router.go(-1)
		},
		saveEvent() {
			let _this = this;
			this.$validator.validateAll().then((result) => {
				if (result) {
					const api = "/api/Room/applyChange";
					const updRoomApplyStatusParam = {
						"id":this.dormitoryApply.id,
						"dormitoryType":_this.dormitoryApply.dormitoryType,
						"idno": _this.stuBase.idno,
						"smtr": _this.dormitoryApply.smtr,
						"account":_this.stuBase.account,
						"applyStatus": _this.dormitoryApply.applyStatus,
						"qualification": _this.dormitoryApply.qualification,
						"qualificationSort":_this.dormitoryApply.qualificationSort,
						"reviewOpinion": _this.dormitoryApply.reviewOpinion,
            "roomBeginDate": _this.roomBeginDate && _this.dormitoryApply.dormitoryType !== "N" ? _this.customFormatter(_this.roomBeginDate) : "",
            "roomEndDate": _this.roomEndDate && _this.dormitoryApply.dormitoryType !== "N" ? _this.customFormatter(_this.roomEndDate) : ""
					}
					let tmpList = [];
					tmpList.push(updRoomApplyStatusParam);
					_this.$axios.post(api, tmpList).then(resp => {
						bootbox.alert(resp.data.msg, function(){
							if (resp.data.status === "success") {
								_this.$router.go(-1);
							}
						});
					});
				} else {
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
		goView(){
			this.showView = "";
		},
		display() {
			document.getElementById("box").style.display = "block";
		},
		disappear() {
			document.getElementById("box").style.display = "none";
		},
		isRequired(){
			return (this.dormitoryApply.dormitoryType == "N" && !this.stuIsExists && !this.isLogin) ? "column-required" : "";
		}
	},
	computed: {
		isInfo(){
			let isShow = false;
			if(this.$route.name != "stay.apply.new"){
				isShow = true;
			}
			return isShow;
		},
		isForeignStudent() {
			return this.dormitoryApply.stuIdentity == 4;
		},
		currentStudentIdentityLabel() {
			const match = this.identiList.find(item => item.commCode == this.dormitoryApply.stuIdentity);
			return match ? match.commValue : "";
		},
		telValidationRule() {
			return this.isForeignStudent ? "required" : "required|tel";
		},
		phoneValidationRule() {
			return this.isForeignStudent ? "required|max:20" : "required|phone";
		},
		parentPhoneValidationRule() {
			return this.isForeignStudent ? "required|max:20" : "required|phone";
		},
		unitAdminTitle(){
			let str = "";
			if(this.dormitoryApply.roomReason == 1){
				str = "系助理/單位行政：";
			}else if(this.dormitoryApply.roomReason == 2){
				str = "指　導　教　授：";
			}else if(this.dormitoryApply.roomReason == 9){
				str = "導　　　師　　：";
			}
			return str;
		},
		unitSuperTitle(){
			let str = "";
			if(this.dormitoryApply.roomReason == 1){
				str = "系主任/單位主管：";
			}else if(this.dormitoryApply.roomReason == 2){
				str = "系　主　任　　：";
			}else if(this.dormitoryApply.roomReason == 9){
				str = "系　主　任　　：";
			}
			return str;
		},

	},
	watch:{
		idno: function (val) {
			if(val){
				this.stuBase.idno = val.toUpperCase();
			}
		},
		roomBeginDate:function(val){
			let date = new Date(val);
			if(new Date(this.roomEndDate) < date){
				this.roomEndDate = date;
			}
			this.endState.disabledDates.to = date;
		},
		ssym(val){
			this.selectDeptList = this.deptList.filter(item => {
				return item.commParentCode == val;
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>

</style>
